import type { IErrorResponseProblem, ResponseErrorPayload } from "./payload";
import { replaceUuid } from "./utils/replaceUuid";

export class FetchResponseError extends Error {
    [key: symbol]: boolean;
    name = "FetchResponseError";

    constructor(
        message: string,
        public response: Response | null,
        symbol: symbol,
    ) {
        super(message);
        this.response = response;
        this[symbol] = true;
    }
}

export class ResponseError extends Error {
    readonly cause: string | undefined;

    readonly problem?: IErrorResponseProblem;

    readonly name: string;

    readonly status: number;

    readonly response?: string;

    readonly err?: string;

    readonly formattedMessage?: string;

    constructor(payload: Readonly<ResponseErrorPayload>) {
        const { url, method, body, name, status, response, err, problem } = payload;
        const errorMessage = typeof name === "string" ? name : JSON.stringify(name);
        const brokenDownUrl = url && url?.indexOf("?") !== -1 ? url.split("?") : [url];
        const [urlWithoutQueryParams, queryParams] = brokenDownUrl;
        const sanitizedUrl = replaceUuid(urlWithoutQueryParams);

        const messageParts = [
            `URL: ${url}`,
            `Method: ${method}`,
            queryParams ? `Query Params: ${queryParams}` : "",
            status ? `Status: ${status}` : "",
            body ? `Req Body: ${body}` : "",
            errorMessage ? `Error Message: ${errorMessage}` : "",
            response ? `Response: ${response}` : "",
            err ? `Err: ${err}` : "",
        ];

        const formattedMessage = messageParts.filter(Boolean).join(". ");
        super(`Request failed with status: ${status} for url: ${sanitizedUrl}`);

        this.cause = body;
        this.name = name;
        this.problem = problem;
        this.status = status;
        this.response = response;
        this.err = err;
        this.formattedMessage = formattedMessage;
    }
}

export const withFullResponseSymbol = Symbol("withFullResponse");

export const HTTP_METHOD = {
    get: "GET",
    post: "POST",
    delete: "DELETE",
    patch: "PATCH",
    put: "PUT",
} as const;

export const RESOURCE_NOT_FOUND_TYPE = "https://api-docs.similarweb.com/error/resource-not-found";
